import React from 'react';

import { NotesEntityFields } from 'common/graphql/__generated__/NotesEntityFields';
import { NotesSectionProps } from 'common/components/NotesSection';
import { GenericNotesSection } from 'common/components/ActionMenu/Notes';

import {
  NoteSupplierCreate,
  NoteSupplierCreateVariables,
} from 'settings/account/supplier/view/ActionMenu/SupplierNotes/__generated__/NoteSupplierCreate';

import NOTE_TRANSACTION_CREATE from '../../../../../../../../../../settings/account/supplier/view/ActionMenu/SupplierNotes/NoteSupplierCreate.graphql';

type NotesProps = Pick<NotesSectionProps, 'listRefreshRequest'> & {
  id: string;
  data: NotesEntityFields[];
  loading?: boolean;
};

export const Notes: React.FC<NotesProps> = ({
  id,
  listRefreshRequest,
  data,
  loading,
}) => {
  return (
    <GenericNotesSection<any, NoteSupplierCreate, NoteSupplierCreateVariables>
      entityId={id}
      data={data}
      loading={loading}
      mutationDocument={NOTE_TRANSACTION_CREATE}
      listRefreshRequest={listRefreshRequest}
    />
  );
};
